import { Component, OnInit } from '@angular/core';
import { SemCallsR10Component } from '../sem-calls-r10/sem-calls-r10.component';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
@Component({
	selector: 'app-sem-calls-r10-reskin',
	templateUrl: './sem-calls-r10-reskin.component.html',
	styleUrls: ['./sem-calls-r10-reskin.component.css']
})
export class SemCallsR10ReskinComponent extends SemCallsR10Component implements OnInit {
	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
	}

	ngOnInit(): void {
		super.ngOnInit();
	}
}
